import { render, staticRenderFns } from "./ConfigurationDataMartsRouterView.vue?vue&type=template&id=4ad49d06&scoped=true&"
import script from "./ConfigurationDataMartsRouterView.vue?vue&type=script&lang=js&"
export * from "./ConfigurationDataMartsRouterView.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationDataMartsRouterView.vue?vue&type=style&index=0&id=4ad49d06&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad49d06",
  null
  
)

export default component.exports